import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Section from '@common/Section';
import Row from '@common/Row';
import Img from '@common/Image';
import Heading from '@common/Heading';

const Border = ({ data }) => {
  const {
    title,
    showTitle,
    images,
    fullwidth,
    textClass
  } = data;
  return (
    <Section>
      <Container fullwidth={fullwidth}>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        {images &&
          <Row className={clsx({'row-cols-sm-2 row-cols-lg-3 gy-3':images.length > 1})}>
            {images.map((image, index) => (
              <div key={index} className='d-flex'>
                <div className='flex-fill p-3 border border-2 border-dark-grey-4 rounded'>
                  <div className='text-start mb-3'>
                    <Img image={image.gatsbyImageData} file={image.file} />
                  </div>
                  <div className={clsx('d-flex flex-column', textClass)}>
                    {image.title && <div className='fs-24 fw-medium mb-3'>{image.title}</div>}
                    {image.description && <p className='fs-18'>{image.description}</p>}
                  </div>
                </div>
              </div>
            ))}
          </Row>
        }
      </Container>
    </Section>
  )
}

export default Border
